/* Reformly V4 nav — mega-menu panels.

   Mirrors the export's own state machine:

     - hovering a top link with a panel opens that panel (openMenu(name))
     - moving between top links swaps panels with no close in between
     - leaving the whole nav closes after 120ms (`_closeTimer`), so crossing
       the gap between a link and its panel does not flicker it shut
     - the open link keeps a solid underline (`shopUnderline`)
     - the card turns opaque while a panel is open (`navBg`)

   Hover, not click, because that is what the design does — but every trigger
   is still focusable and Escape closes, so the panels are reachable without a
   pointer. Below 1080 the triggers are not rendered and this does nothing.
*/
(function () {
  var roots = document.querySelectorAll('[data-rfn]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    var card = root.querySelector('.rfn__card');
    var triggers = root.querySelectorAll('[data-rfn-panel]');
    var panels = root.querySelectorAll('[data-rfn-panel-for]');
    if (!card || !triggers.length) return;

    var closeTimer = null;
    var openId = null;

    /* The panels only exist above 1080. Checked at call time rather than once
       at load: a desktop window dragged narrow must stop opening them, and a
       narrow one widened must start. */
    var canOpen = function () {
      return window.matchMedia('(min-width: 1080px)').matches;
    };

    function paint() {
      Array.prototype.forEach.call(panels, function (p) {
        var on = p.getAttribute('data-rfn-panel-for') === openId;
        p.hidden = !on;
      });
      Array.prototype.forEach.call(triggers, function (t) {
        var on = t.getAttribute('data-rfn-panel') === openId;
        t.classList.toggle('is-open', on);
        t.setAttribute('aria-expanded', on ? 'true' : 'false');
      });
      card.classList.toggle('is-open', openId !== null);
    }

    function open(id) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (!canOpen() || openId === id) return;
      openId = id;
      paint();
    }

    function close(now) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openId === null) return;
      if (now) {
        openId = null;
        paint();
        return;
      }
      /* 120ms, the export's. Long enough to cross the gap between a link and
         the panel below it, short enough not to feel stuck open. */
      closeTimer = setTimeout(function () {
        openId = null;
        paint();
      }, 120);
    }

    Array.prototype.forEach.call(triggers, function (t) {
      var id = t.getAttribute('data-rfn-panel');
      t.addEventListener('mouseenter', function () { open(id); });
      t.addEventListener('focus', function () { open(id); });
      /* A trigger that is also a link must still navigate on click; opening on
         click as well would mean a tap both opened the panel and left the page. */
    });

    /* THE SUB-PANEL IS STATE, NOT HOVER.

       Hovering "Grip Socks" in the rail shows its links over the first tile.
       Keying that on `:hover` meant the panel vanished the moment the pointer
       left the row — and the links are in the other column, so they could
       never be reached. The export does not use hover for this: mouseenter on
       a parent row SETS `sockSub`, and only mouseenter on a different rail row
       or a tile clears it, so the panel survives the journey across the gap.

       Mirrored here as an attribute on the grid, which the per-menu rules in
       reformly-nav.liquid key off. Index, not id: the pairing with
       data-rfn-subpanel is positional. */
    Array.prototype.forEach.call(root.querySelectorAll('.rfn__panel-grid'), function (grid) {
      var setSub = function (n) {
        if (n === null) grid.removeAttribute('data-rfn-subopen');
        else grid.setAttribute('data-rfn-subopen', n);
      };

      Array.prototype.forEach.call(grid.querySelectorAll('[data-rfn-sub]'), function (row) {
        row.addEventListener('mouseenter', function () {
          setSub(row.getAttribute('data-rfn-sub'));
        });
      });

      /* Everything else in the panel clears it: the rail rows with no children
         and the promo tiles. The sub-panel itself is deliberately NOT in this
         list — moving into it is the whole point. */
      Array.prototype.forEach.call(
        grid.querySelectorAll('.rfn__panel-link:not(.rfn__panel-link--parent), a.rfn__tile'),
        function (el) {
          el.addEventListener('mouseenter', function () { setSub(null); });
        }
      );

      /* And it goes with the mega panel. Without this the sub stays latched and
         is still showing the next time that panel opens. */
      var owner = grid.closest('[data-rfn-panel-for]');
      if (owner) owner.addEventListener('mouseleave', function () { setSub(null); });
    });

    /* Links WITHOUT a panel close it. The export binds `closeNow` to App and
       Sale for exactly this: sliding past them from Socks should dismiss the
       Socks panel rather than leave it hanging. */
    Array.prototype.forEach.call(root.querySelectorAll('.rfn__link'), function (l) {
      if (l.hasAttribute('data-rfn-panel')) return;
      l.addEventListener('mouseenter', function () { close(true); });
    });

    /* BOUND TO THE CARD, not the root — the root is the wrong shape.

       `.rfn` is full-bleed (measured 1440 wide at 1440) while the card and the
       panel hanging off it are 1300 centred, so there is a ~70px gutter down
       each side that belongs to the root but shows nothing. Leaving sideways
       into that gutter never fired `mouseleave`, and the panel stayed open with
       the pointer well clear of the menu — reported, then reproduced: exiting
       left at panel height left it open indefinitely.

       The card is the right boundary because it contains BOTH the link row and
       the panel (card 51-477 encloses panel 111-477), which is what the old
       comment here was worried about: a listener that fired while the pointer
       travelled from a link down into its own panel. It does not — that whole
       journey is inside the card. */
    card.addEventListener('mouseleave', function () { close(false); });
    card.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close(true);
    });

    /* Focus moving out of the nav entirely closes it — otherwise tabbing from
       the last panel link into the page leaves the panel open behind you. */
    document.addEventListener('focusin', function (e) {
      if (openId !== null && !root.contains(e.target)) close(true);
    });

    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 1080px)');
      var onChange = function () { close(true); };
      if (mq.addEventListener) { mq.addEventListener('change', onChange); }
      else if (mq.addListener) { mq.addListener(onChange); }
    }

    /* ---------- Market switch, without leaving the page ----------

       The theme's localization-form.js answers a click by calling
       form.submit() — a real navigation to /localization, which bounces back
       via the form's return_to. That works, but the buyer watches the page go
       away and come back, and any hiccup in the round trip leaves them parked
       on /localization looking at nothing.

       POST the same form with fetch instead and reload in place. Identical
       request, identical result server-side; no intermediate page.

       Bound in the CAPTURE phase with stopImmediatePropagation so it runs
       before localization-form.js's own bubble-phase handler, which would
       otherwise submit the form underneath us and navigate anyway. */
    var locForm = root.querySelector('.rfn__loc form');
    if (locForm) {
      var locInput = locForm.querySelector('input[name="country_code"]');
      Array.prototype.forEach.call(root.querySelectorAll('.rfn__loc-link'), function (link) {
        link.addEventListener('click', function (e) {
          var iso = link.getAttribute('data-value');
          if (!iso || !locInput) return;
          e.preventDefault();
          e.stopImmediatePropagation();

          /* Already on it — just close the card. */
          if (iso === locInput.value) {
            var btn = root.querySelector('.rfn__loc-btn');
            var panel = root.querySelector('.rfn__loc-list');
            if (panel) panel.setAttribute('hidden', '');
            if (btn) btn.setAttribute('aria-expanded', 'false');
            return;
          }

          locInput.value = iso;
          link.setAttribute('aria-busy', 'true');

          fetch(locForm.getAttribute('action') || '/localization', {
            method: 'POST',
            body: new FormData(locForm),
            headers: { 'Accept': 'text/html' }
          })
            .then(function () { window.location.reload(); })
            /* If the request fails, fall back to the behaviour we replaced
               rather than leaving the buyer on a dead control. */
            .catch(function () { locForm.submit(); });
        }, true);
      });
    }

    /* ---------- Scrolled state (phones) ----------

       The mobile export flips at `scrollY > 88` — its own nav height — from a
       flush square bar to the inset floating pill. CSS owns the appearance;
       this only decides when.

       rAF-throttled and passive: a scroll listener that writes to the DOM on
       every event is the classic way to make a phone nav judder. The class is
       only written when it actually changes.

       Not gated on a media query here — the CSS already scopes every scrolled
       rule to max-width 899, so above that the class is inert. One less thing
       to keep in step. */
    /* TWO THRESHOLDS, NOT ONE — the bar used to flutter around the boundary.

       With a single `> 88` test, any scroll that hovers near 88 flips the
       class on and off repeatedly, restarting the 220ms transition each time.
       The bar visibly shimmers between flush and floating without the finger
       really moving.

       A phone makes this far likelier than a desktop, for two reasons that do
       not exist here in a headless browser:

         - momentum scrolling drifts back and forth across a point as it settles
         - collapsing the iOS address bar changes scrollY by ~60px on its own,
           with no gesture at all, which can cross 88 by itself

       So: detach at 88, which is the export's number and stays the moment the
       bar lifts, but do not re-attach until 56. The 32px band is wide enough
       that nothing short of a deliberate scroll back to the top crosses both,
       and because the bar only re-attaches near the top, the asymmetry is
       invisible in use. */
    var ENTER_AT = 88;
    var LEAVE_AT = 56;

    var scrolled = false;
    var ticking = false;
    function syncScrolled() {
      var y = window.scrollY || window.pageYOffset || 0;
      var next = scrolled ? y > LEAVE_AT : y > ENTER_AT;
      if (next !== scrolled) {
        scrolled = next;
        root.classList.toggle('is-scrolled', scrolled);
      }
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncScrolled(); });
    }, { passive: true });
    /* Run once: a reload part-way down the page must start in the right state. */
    syncScrolled();

    /* ---------- Mobile drawer ----------

       A VIEW SWAP, not an accordion: tapping "Grip Socks" replaces the whole
       list with its own, and a back row returns. That is what the export does
       (`mainMenuOpen` / `sockMenuOpen` are mutually exclusive), and it is why
       every view is rendered up front and only `hidden` moves.
    */
    var drawer = document.getElementById(
      (root.querySelector('[data-rfn-burger]') || {}).getAttribute
        ? root.querySelector('[data-rfn-burger]').getAttribute('aria-controls')
        : ''
    );
    var burger = root.querySelector('[data-rfn-burger]');
    if (!drawer || !burger) return;

    var views = drawer.querySelectorAll('[data-rfn-view]');
    var lastFocus = null;

    var panelEl = drawer.querySelector('.rfn-drawer__panel');

    /* HAND THE CLOSED STATE OVER FROM `hidden` TO `inert`, once, at init.

       The markup ships with `hidden` so the sheet is not visible before this
       script runs and stays hidden if it never does. From here on the closed
       state is `inert`: it keeps the subtree out of the a11y tree and
       unfocusable, but unlike `hidden` (display) and `visibility` it changes
       nothing inherited, so a toggle no longer invalidates the style of the
       whole drawer. The sheet is invisible because the scrim and panel sit at
       opacity 0 until `.is-open`.

       Paying it here means the one-time layout and style pass lands during
       load rather than on the user's first tap. */
    if (drawer.hidden) {
      drawer.hidden = false;
      drawer.setAttribute('inert', '');
    }

    function showView(name) {
      Array.prototype.forEach.call(views, function (v) {
        v.hidden = v.getAttribute('data-rfn-view') !== name;
      });
      /* Back to the top on every swap — the sheet scrolls, and arriving
         part-way down a sub-list reads as a broken transition.

         The element is looked up ONCE above rather than per call: querySelector
         inside a handler that also writes scrollTop is a read-then-write on the
         same frame, which is the shape that forces a synchronous layout. */
      if (panelEl) panelEl.scrollTop = 0;
    }

    /* OPEN/CLOSE IS ANIMATED, which is why `hidden` is not the only thing that
       moves any more.

       `hidden` resolves to `display: none`, and display is not animatable — the
       sheet appeared and vanished in one frame while the export slides it in
       from the left behind a fading scrim. So the attribute still controls
       whether the drawer is in the layout (and still hides it from assistive
       tech when shut), and a separate `is-open` class drives the transition.

       OPENING needs two frames, not one. Setting `hidden = false` and adding
       the class in the same tick gives the browser nothing to interpolate
       from: it computes the final state once and paints it. The nested rAF
       lets the closed state render first, so the transition has a start.

       CLOSING waits for the transition to finish before re-hiding, with a
       timer as the backstop — `transitionend` never fires when the element is
       already in its end state, under prefers-reduced-motion, or if the panel
       is display:none'd by something else mid-flight, and without the fallback
       the drawer would stay in the DOM holding the page scroll lock. */
    var closeTimer = null;
    /* Separate from closeTimer: the page lock is applied after the open
       animation and released after the close one, so both are outside the
       frames that have to stay clean. See openDrawer. */
    var lockTimer = null;

    function openDrawer() {
      lastFocus = document.activeElement;
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }

      /* EVERYTHING THAT CAN FORCE LAYOUT IS DEFERRED PAST THIS FRAME.
         The tap handler now only flips attributes and a class — see the note
         after this function for what was in here and what it cost. */
      drawer.removeAttribute('inert');
      burger.setAttribute('aria-expanded', 'true');
      showView('main');

      /* ONE frame, not two. The two-rAF dance existed because `hidden` meant
         `display: none` and the browser had nothing to interpolate from until
         the closed state had painted. The closed state is now
         `visibility: hidden` with layout already computed, so a single frame is
         enough for the transition to have a start value. */
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });

      /* THE PAGE LOCK IS DEFERRED PAST THE ANIMATION, and it is the single
         biggest thing that was making this feel heavy.

         `overflow: hidden` on <html> changes the document's scroll container,
         so the browser relayouts the WHOLE PAGE — measured on the home page at
         4x throttle: 24.2ms to apply, 22.5ms to restore. Every drawer
         mutation put together is under 4ms, so this one line was the dropped
         frame on open and on close.

         Applying it after the sheet has finished arriving moves that relayout
         into dead time. The page cannot be scrolled in the meantime anyway:
         the scrim covers it with `touch-action: none`, and the panel carries
         `overscroll-behavior: contain`.

         320ms = just past the 300ms transform. Cancelled by closeDrawer if the
         sheet is dismissed before it fires, so a quick open/close never pays
         the cost at all. */
      if (lockTimer) clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        document.documentElement.style.overflow = 'hidden';
        lockTimer = null;
      }, 320);

      /* focus() AFTER the frame, and with preventScroll.

         Both halves matter. Calling it synchronously forced a style/layout
         flush inside the handler, and focus() on an element in a freshly shown
         scroll container also makes the browser scroll it into view — a second
         layout read, and on a phone it can jump the panel. `preventScroll`
         removes the scrolling; the rAF moves the remaining cost out of the
         frame the user is waiting on. */
      requestAnimationFrame(function () {
        var first = drawer.querySelector('[data-rfn-drawer-close]');
        if (first) first.focus({ preventScroll: true });
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');

      /* Don't let a pending lock land after we have started closing. */
      if (lockTimer) { clearTimeout(lockTimer); lockTimer = null; }

      /* Deferred and preventScroll for the same reasons as the open path:
         returning focus to the burger synchronously flushed layout in the frame
         the close animation starts in, which is the frame that has to be clean
         for the sheet to move smoothly. */
      requestAnimationFrame(function () {
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      });

      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        /* `inert`, not `hidden`: re-hiding with display would put the layout
           cost back on the NEXT open. The sheet is already invisible by then —
           the class came off 340ms ago — so this only re-arms the a11y and
           focus guard. */
        drawer.setAttribute('inert', '');
        /* Releasing the lock relayouts the page (22.5ms), so it waits for the
           close animation to be over for the same reason applying it does. */
        document.documentElement.style.overflow = '';
        closeTimer = null;
      }, 340);
    }

    /* Keyed on the CLASS, not on `hidden`. During the closing transition the
       drawer is still un-hidden for ~340ms, so testing `hidden` here made a
       burger tap in that window call closeDrawer again — the sheet stayed
       shut and the next tap did nothing. */
    burger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) { closeDrawer(); } else { openDrawer(); }
    });

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-rfn-drawer-close]'), function (el) {
      el.addEventListener('click', closeDrawer);
    });

    Array.prototype.forEach.call(drawer.querySelectorAll('[data-rfn-view-open]'), function (el) {
      el.addEventListener('click', function () {
        showView(el.getAttribute('data-rfn-view-open'));
      });
    });

    document.addEventListener('keydown', function (e) {
      /* Keyed on the class, like the burger toggle. `!drawer.hidden` is now
         always true — init cleared the attribute for good — so this would have
         fired closeDrawer on every Escape anywhere on the page. */
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    /* BACK FROM A LINK TAPPED INSIDE THE DRAWER leaves it open.

       The nav is a section, re-rendered server-side on every page, so there
       is no shared state carrying it across — the drawer is open because
       Safari restored the PREVIOUS page from bfcache. A bfcache restore
       hands back the live DOM exactly as it was abandoned: `.is-open` still
       set, `inert` still cleared, the scroll lock still applied. No script
       re-runs, because the document was never torn down, so nothing closes
       it.

       Closing it here puts the page back in the state a reader expects:
       they tapped a link, came back, and should be looking at the page they
       came back to rather than the menu they left open on top of it.

       Not gated on `event.persisted` alone. Shopify sends no-store on most
       pages, so a back is often a history RELOAD rather than a true bfcache
       restore; `back_forward` covers that case. Harmless either way — on a
       fresh load the drawer is already closed and closeDrawer() is a no-op. */
    window.addEventListener('pageshow', function (e) {
      var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (!e.persisted && !(nav && nav.type === 'back_forward')) return;
      if (drawer.classList.contains('is-open')) closeDrawer();
    });

    /* Crossing up to the desktop layout with the sheet open would leave the
       page scroll-locked behind a drawer CSS has just hidden. */
    if (window.matchMedia) {
      var dmq = window.matchMedia('(min-width: 1080px)');
      var onWide = function () {
        if (drawer.classList.contains('is-open')) closeDrawer();
      };
      if (dmq.addEventListener) { dmq.addEventListener('change', onWide); }
      else if (dmq.addListener) { dmq.addListener(onWide); }
    }
  });
})();
